import { ApiError } from '@/services/apiClient';

export const APPROVAL_ERROR_FALLBACK =
  'Please try again, or contact your administrator if the problem continues.';

// Statuses the approval endpoints use for business validation, where the API
// returns a curated `message` written for the approver.
const USER_FACING_STATUSES = [400, 409];

const MAX_LENGTH = 300;

// Fragments that indicate framework or database detail rather than a message
// written for an approver.
const INTERNAL_DETAIL_MARKERS = [
  'exception',
  'stack trace',
  'system.',
  'microsoft.',
  'traceid',
  'inner error',
];

/**
 * Description to show under an approval/rejection failure toast.
 *
 * Only the API's own validation message is shown — anything else (unexpected
 * status codes, framework `ProblemDetails` titles, exception text) falls back to
 * generic guidance so internal detail never reaches the approver.
 */
export function getApprovalErrorMessage(error: unknown): string {
  if (!(error instanceof ApiError) || !USER_FACING_STATUSES.includes(error.status)) {
    return APPROVAL_ERROR_FALLBACK;
  }

  const message = error.data?.message;
  if (typeof message !== 'string') {
    return APPROVAL_ERROR_FALLBACK;
  }

  const trimmed = message.trim();
  if (trimmed.length === 0 || trimmed.length > MAX_LENGTH) {
    return APPROVAL_ERROR_FALLBACK;
  }

  const lower = trimmed.toLowerCase();
  if (INTERNAL_DETAIL_MARKERS.some(marker => lower.includes(marker))) {
    return APPROVAL_ERROR_FALLBACK;
  }

  return trimmed;
}
